import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-21754">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-21755">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21756">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Политика конфиденциальности'
        }]} className="mb-8" data-id="element-21757" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-21758">
            Политика конфиденциальности
          </h1>
          <p className="text-slate-500" data-id="element-21759">Последнее обновление: 15 мая 2026 г.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-21760">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-21761">
          <h2 data-id="element-21762">1. Общие положения</h2>
          <p data-id="element-21763">
            Настоящая Политика конфиденциальности (далее — «Политика»)
            определяет порядок обработки и защиты персональных данных
            пользователей сервиса AstroGuide (далее — «Сервис»). Мы с уважением
            относимся к конфиденциальности ваших данных и прилагаем все усилия
            для их защиты.
          </p>

          <h2 data-id="element-21764">2. Какие данные мы собираем</h2>
          <p data-id="element-21765">
            Для предоставления астрологических услуг мы собираем следующие
            данные:
          </p>
          <ul data-id="element-21766">
            <li data-id="element-21767">
              <strong data-id="element-21768">Регистрационные данные:</strong> имя, адрес электронной
              почты, номер телефона.
            </li>
            <li data-id="element-21769">
              <strong data-id="element-21770">Астрологические данные:</strong> дата, точное время и
              место рождения (необходимы для расчета натальной карты).
            </li>
            <li data-id="element-21771">
              <strong data-id="element-21772">Технические данные:</strong> IP-адрес, тип браузера,
              данные файлов cookie.
            </li>
          </ul>

          <h2 data-id="element-21773">3. Использование данных</h2>
          <p data-id="element-21774">Мы используем ваши данные исключительно для следующих целей:</p>
          <ul data-id="element-21775">
            <li data-id="element-21776">Генерация персональных астрологических отчетов.</li>
            <li data-id="element-21777">Организация консультаций с астрологами платформы.</li>
            <li data-id="element-21778">Улучшение качества работы Сервиса.</li>
            <li data-id="element-21779">
              Отправка важных уведомлений (например, о готовности отчета).
            </li>
          </ul>

          <h2 data-id="element-21780">4. Передача данных третьим лицам</h2>
          <p data-id="element-21781">
            Мы не продаем и не передаем ваши персональные данные третьим лицам
            для маркетинговых целей. Ваши астрологические данные (дата, время,
            место рождения) могут быть переданы выбранному вами астрологу
            исключительно для проведения оплаченной консультации.
          </p>

          <h2 data-id="element-21782">5. Безопасность данных</h2>
          <p data-id="element-21783">
            Мы используем современные методы шифрования и защиты данных для
            предотвращения несанкционированного доступа. Все платежи
            обрабатываются через защищенные шлюзы сертифицированных платежных
            систем.
          </p>

          <h2 data-id="element-21784">6. Ваши права</h2>
          <p data-id="element-21785">Вы имеете право в любой момент:</p>
          <ul data-id="element-21786">
            <li data-id="element-21787">Запросить копию всех ваших данных, хранящихся в Сервисе.</li>
            <li data-id="element-21788">
              Отредактировать или удалить свои данные через настройки Личного
              кабинета.
            </li>
            <li data-id="element-21789">Отозвать согласие на обработку персональных данных.</li>
          </ul>

          <h2 data-id="element-21790">7. Контакты</h2>
          <p data-id="element-21791">
            Если у вас есть вопросы по поводу настоящей Политики
            конфиденциальности, пожалуйста, свяжитесь с нами по адресу:{' '}
            <a href="mailto:privacy@astroguide.ru" data-id="element-21792">privacy@astroguide.ru</a>.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-21793">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-21794">
            Пользовательское соглашение →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-21795">
            Есть вопросы? Свяжитесь с нами
          </button>
        </div>
      </div>
    </div>;
}